import React from 'react';

import BaseDetailScreen from '../BaseDetailScreen';
import './index.css';


const Component = () => (
  <BaseDetailScreen
    pageHeading="Other Factors"
    backTo="/"
    backLabel="Home"
  >
    <div styleName="textContainer">
        Unless the offering statement has been qualified, no money or other
        consideration is being solicited, and if sent, will not be accepted.
        No sales will be made or commitments to purchase accepted until the
        offering statement is qualified.  A prospective purchaser&#39;s
        indication of interest in non-binding.
    </div>
  </BaseDetailScreen>
);

Component.displayName = 'OtherFactors';

export default Component;



// WEBPACK FOOTER //
// ./src/components/OtherFactors/index.js